import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb,} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class ReportStock extends Component {
    constructor(){
        super();
        this.state = {
            table: {
                headers: ['Producto', 'Unidades Disponibles', 'Acciones'],
                name: 'Producto',
                title: 'Productos',
                has_actions: true,
                navigate: false,
                pagination: true,
                url: 'product-stock-branch',
                values: ['id', 'name', 'total'],
                id: 'table_report_stock'
            },
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Inventario de Productos - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Inventario de Productos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!localDB.checkPlanAccessExclude('ticket_service') ? <DynamicTable {...this.state.table} />:<UpgradeAccount/>}
            </div>
        );
    }
}

export default withRouter(ReportStock);



// WEBPACK FOOTER //
// ./src/containers/reports/ReportStock.js